import styled from "@emotion/styled";
import { Skeleton } from "@avenue-8/sidekick-ui";
import { PageScroll } from "@modules/radar/shared/components/RadarPageContent/RadarPageContent.styles";
import {
  PanelContainer,
  GridContainer,
} from "@modules/radar/shared/components/MomentsGrid/MomentsGrid.styles";

const BannerSkeleton = styled(Skeleton)`
  background-color: ${(p) => p.theme.navbar.colors.background};
`;

export function RadarPageContentSkeleton() {
  return (
    <PageScroll>
      <BannerSkeleton variant="rectangular" height={96} width="100%" />
      <PanelContainer>
        <GridContainer>
          {Array.from({ length: 9 }, (_, index) => (
            <Skeleton key={index} variant="rounded" height={220} width="100%" />
          ))}
        </GridContainer>
      </PanelContainer>
    </PageScroll>
  );
}
